import ParticipantsLayoutButton from './components/web/ParticipantsLayoutButton';
/**
 * Toolbar button config that replaces the native tile-view button with the
 * participants-layout picker. Keeps the same `tileview` key/slot.
 */
const participantsLayout = {
    key: 'tileview',
    Content: ParticipantsLayoutButton,
    group: 2
};
/**
 * Hook returning the participants-layout toolbar button (always available).
 *
 * @returns {Object}
 */
export function useParticipantsLayoutButton() {
    return participantsLayout;
}
